/**
 * dashboardSortUtil — Shared sort helper for Clinical Day View patient lists.
 *
 * Supports sorting by "name" (lastName) and "date" (latestDocument.documentDate).
 */

/**
 * Get a comparable date string from a patient for sorting.
 * Checks latestDocument.documentDate first, then document.documentDate.
 */
function getPatientDateStr(patient) {
    return patient.latestDocument?.documentDate || patient.document?.documentDate || "";
}

/**
 * Sort an array of patient objects by the given field and direction.
 * Returns a new sorted array (does not mutate input).
 *
 * @param {Array} patients
 * @param {string} sortField - "name" | "date"
 * @param {string} sortDirection - "asc" | "desc"
 * @returns {Array}
 */
export function sortDashboardPatients(patients, sortField, sortDirection) {
    if (!patients || patients.length === 0) return patients;

    return [...patients].sort((a, b) => {
        if (sortField === "name") {
            const cmp = (a.lastName || "").localeCompare(b.lastName || "");
            return sortDirection === "asc" ? cmp : -cmp;
        }

        if (sortField === "date") {
            const dateA = getPatientDateStr(a);
            const dateB = getPatientDateStr(b);
            const cmp = dateA.localeCompare(dateB);
            return sortDirection === "asc" ? cmp : -cmp;
        }

        // Default: name asc
        return (a.lastName || "").localeCompare(b.lastName || "");
    });
}
